export default __webpack_public_path__ + "static/media/aws-dynamodb.abdd7901.svg";